var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeidos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 606,
    viewBox: "0 0 594 144.1",
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m192.4 34.9 23.1-5.3v112.6h-23.1zm107.7 94.3c-7.4 9.4-19.6 14.8-31.6 14.8-23.1 0-41.6-15.4-41.6-39.3s18.5-39.3 41.6-39.3c21.6 0 35.2 15.4 35.2 39.3v7.2h-53.7c1.9 8.8 8.5 14.5 17.4 14.5 7.6 0 12.6-3.8 16.5-9.1zm-19.6-33c.2-7.7-5.9-14.2-14.2-14.2-10.2 0-15.7 6.9-16.3 14.2zm151.4 45.9h-21.3v-9.9h-.3c-3.6 5.4-12.5 11.7-23 11.7-22.2 0-36.8-16-36.8-38.7 0-20.8 12.9-39.9 34.2-39.9 9.5 0 18.5 2.6 23.7 9.9h.3v-40.3l23.1-5.3v112.5zm-39.8-56.4c-11.6 0-18.5 7.7-18.5 19s6.9 19 18.5 19 18.5-7.7 18.5-19-6.9-19-18.5-19m91.1-20.3c23.1 0 41.6 15.4 41.6 39.3s-18.5 39.3-41.6 39.3-41.6-15.4-41.6-39.3 18.5-39.3 41.6-39.3m0 58.2c11.5 0 18.5-7.7 18.5-19s-7-19-18.5-19c-11.6 0-18.5 7.7-18.5 19s6.9 19 18.5 19m93.7-34.3c-3.4-4.2-7.9-6.3-13.4-6.3-3.9 0-8.5 1.7-8.5 6.2 0 11.1 39 1.7 39 30.2 0 19.1-18.5 24.7-34.5 24.7-10.5 0-22-2.6-29.4-10.2l14-15.6c4.3 5.2 9.4 8.2 16.3 8.2 5.2 0 10.5-1.4 10.5-5.4 0-12-39-1.9-39-30.4 0-17.6 15.7-25.3 31.4-25.3 9.9 0 20.8 2.5 27.8 9.9zm-260.8-22.1h23.1v74.9h-23.1zm23.2-32.2h-23.1v19.2h23.1z",
    fill: "#12034e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m78.8 85.3-25.2-18.7 118.9-35.3zm-78.8-58.4 24.2 18 6.2-17.2z",
    fill: "#d3d2d2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m40.4 0-10 27.7 142 3.6zm-28.5 79 41.7-12.4-29.4-21.7z",
    fill: "#12034e"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30.5 27.7-6.3 17.2 29.4 21.7 118.9-35.3z",
    fill: "#8d248a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeidos);
export default __webpack_public_path__ + "static/media/leidos.bd5a2678826c5414ddbef5dbfde78abc.svg";
export { ForwardRef as ReactComponent };